module.exports = __webpack_public_path__ + "static/media/icon_favourites_remove_600×558.59161552.png";